<template>
  <div class="productDetails">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Equipments_Information') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Equipment_Name') }}：</span>
        <a-input v-model="item.factoryEquip.equipName"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Model_Nr') }}：</span>
        <a-input v-model="item.factoryEquip.equipModel"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Quantity') }}：</span>
        <a-input v-model="item.factoryEquip.equipQuantity"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Maintenance_Records') }}:</span>
        <a-radio-group
          name="radioGroup"
          v-model="item.factoryEquip.equipMaintainrecords"
        >
          <a-radio value="1">{{ $tc('lang.factoryReport.Yes') }}</a-radio>
          <a-radio value="2">{{ $tc('lang.factoryReport.NO') }}</a-radio>
        </a-radio-group>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.factoryReport.Equipment') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Equipment_List') }}</span>
      <div class="img">
        <show-img
          :data="productDetails.freportEquipmentlist"
          :otherData="{
            mediaName: '设备清单',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportEquipmentlist',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Maintenance_Records') }}</span>
      <div class="img">
        <show-img
          :data="productDetails.freportMaintenancerecords"
          :otherData="{
            mediaName: '设备维护记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportMaintenancerecords',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
      data: [],
    };
  },
  computed: {
    factoryDetails: {
      get() {
        return this.$store.state.report.factoryDetails;
      },
      set(val) {
        this.$store.commit('report/save', { factoryDetails: val });
      },
    },
    productDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.factoryImgList.productDetails,
          ),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/factory-equip/seachFactoryEquip', {
          freportId: this.factoryDetails.freportId,
        })
        .then(data => {
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    handleSubmit(item) {
      const factoryEquip = item.factoryEquip;
      const media = [];
      item.media.forEach(item => {
        media.push(item.id);
      });
      let newData = [
        {
          ...factoryEquip,
          equipPhoto: media.join(','),
        },
      ];
      this.$http
        .post('/hzwmj/factory-equip/saveOrUpdateFactoryEquip', {
          data: newData,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getDetail();
            // this.details = data;
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    //保存图片
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      this.productDetails.freportEquipmentlist.forEach(item => {
        fileList.push(item.id);
      });
      this.productDetails.freportMaintenancerecords.forEach(item => {
        fileList1.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '基本信息',
        freportMediatype: '1',
        modelType: '4',

        freportEquipmentlist: fileList.join(','),
        freportMaintenancerecords: fileList1.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.productDetails {
  .productProcess-list {
    margin-bottom: 20px;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
